// Load Vimeo Player API
const loadVimeoAPI = () => {
	const script = document.createElement( 'script' );
	script.src = 'https://player.vimeo.com/api/player.js';
	document.head.appendChild( script );
};

// Create iframe element with video settings
const createVideoIframe = videoUrl => {
	const iframe = document.createElement( 'iframe' );
	const iframeAttributes = {
		src: `${ videoUrl }?autoplay=1&muted=1`,
		frameborder: '0',
		allow: 'autoplay; fullscreen; picture-in-picture',
		allowfullscreen: '',
	};

	Object.entries( iframeAttributes ).forEach( ( [ attr, value ] ) => {
		iframe.setAttribute( attr, value );
	} );

	iframe.style.width = '100%';
	iframe.style.height = '100%';

	return iframe;
};

// Initialize Vimeo player
const initializePlayer = iframe => {
	if ( typeof window.Vimeo === 'undefined' ) {
		throw new Error( 'Vimeo SDK is not loaded' );
	}

	const player = new window.Vimeo.Player( iframe );
	player.play();
};

// Handle video placeholder click
const handlePlaceholderClick = placeholder => {
	const wrapper = placeholder.closest( '.video-wrapper' );
	const oldIframe = wrapper.querySelector( 'iframe' );
	const newIframe = createVideoIframe( placeholder.dataset.videoUrl );

	oldIframe.parentNode.replaceChild( newIframe, oldIframe );
	placeholder.style.display = 'none';

	newIframe.addEventListener( 'load', () => initializePlayer( newIframe ) );
};

// Initialize video placeholders
const initVideoPlaceholders = () => {
	const videoPlaceholders = document.querySelectorAll( '.video-placeholder' );
	videoPlaceholders.forEach( placeholder => {
		placeholder.addEventListener( 'click', () => handlePlaceholderClick( placeholder ) );
	} );
};

// Main initialization - only run if .wp-block-videos exists
const videoBlock = document.querySelector( '.wp-block-videos' );
if ( videoBlock ) {
	loadVimeoAPI();
	document.addEventListener( 'DOMContentLoaded', initVideoPlaceholders );
}
